import * as types from './mutation-types'

export const loadQuestions = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.post('customer/get/nps/questions').then((response) => {
            commit(types.LOAD_QUESTIONS, response.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}
export const setQuestionsResponses = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('customer/nps/give/response', data).then((response) => {
            //commit(types.LOAD_QUESTIONS, response.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}


